/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterVSmall = createReactComponent("letter-v-small", "IconLetterVSmall", [
  ["path", { d: "M10 8l2 8l2 -8", key: "svg-0" }]
]);

export { IconLetterVSmall as default };
//# sourceMappingURL=IconLetterVSmall.js.map
